const btnClose = document.querySelector('.block_disclaimer_box_close');
const btnPopup = document.querySelector('.disclaimer_popup_box_wrap');
const popup_box = document.querySelector('.block_disclaimer_box');

if(btnClose){
    btnClose.onclick = () => {
        popup_box.classList.add('hidden');
    };
}

if(btnPopup){
    btnPopup.onclick = () => {
        document.querySelector('.disclaimer_popup_box_m').innerHTML = document.querySelector('.disclaimer_popup_box_inner').innerHTML;
        document.querySelector('.disclaimer_popup_box_m').style.display = "block";
        document.querySelector('body').classList.add('add-overlay');

        const popupElem = document.querySelector('.disclaimer_popup_box_m');
        popupElem.querySelector('.disclaimer_popup_close').onclick = function(){
            document.querySelector('.disclaimer_popup_box_m').innerHTML = '';
            document.querySelector('.disclaimer_popup_box_m').style.display = "none";
            document.querySelector('body').classList.remove('add-overlay');
        }
    };
}